import { render, staticRenderFns } from "./ContactTags.container.vue?vue&type=template&id=5dc736c2&scoped=true&"
import script from "./ContactTags.container.vue?vue&type=script&lang=js&"
export * from "./ContactTags.container.vue?vue&type=script&lang=js&"
import style0 from "./ContactTags.container.vue?vue&type=style&index=0&id=5dc736c2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dc736c2",
  null
  
)

export default component.exports